import React from "react";
import { Link } from "react-router-dom";
import { useFetch } from "../hooks/useFetch";
import { apiEndpoints, API_BASE_URL } from "../utils/api";

export const Footer = () => {
  // Usar las MISMAS llamadas que el Header original (que funcionan)
  const { data: settings, loading: settingsLoading } = useFetch(
    apiEndpoints.settings.public()
  );
  const { data: mainMenu, loading: mainMenuLoading } = useFetch(
    apiEndpoints.menus.single(1)
  );

  // NUEVOS: Cargar menús adicionales para footer
  const { data: footerMenu, loading: footerMenuLoading } = useFetch(
    apiEndpoints.menus.single(2)
  );
  const { data: legalMenu, loading: legalMenuLoading } = useFetch(
    apiEndpoints.menus.single(5)
  );

  // Procesar datos igual que el Header original
  const siteData = {
    name: settings?.site?.name || "Red Arauca",
    logo: settings?.site?.logo || null,
    description:
      settings?.site?.description ||
      "Red de medios de comunicación comprometida con informar de manera veraz y oportuna sobre los acontecimientos más relevantes de nuestra región.",
    email: settings?.contact?.email || "info@redarauca.com",
    phone: settings?.contact?.phone || "+57 123 456 7890",
    address: settings?.contact?.address || null,
    social: {
      facebook: settings?.social?.facebook || null,
      twitter: settings?.social?.twitter || null,
      instagram: settings?.social?.instagram || null,
      youtube: settings?.social?.youtube || null,
      linkedin: settings?.social?.linkedin || null,
    },
  };

  const mainMenuItems = mainMenu?.items || [];
  const footerMenuItems = footerMenu?.items || [];
  const legalMenuItems = legalMenu?.items || [];

  return (
    <footer className="footer">
      <style jsx>{`
        .footer {
          background: linear-gradient(
            135deg,
            #065f46 0%,
            #047857 50%,
            #059669 100%
          );
          color: white;
          position: relative;
          overflow: hidden;
        }

        .footer::before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="dots" width="20" height="20" patternUnits="userSpaceOnUse"><circle cx="10" cy="10" r="1" fill="rgba(255,255,255,0.1)"/></pattern></defs><rect width="100" height="100" fill="url(%23dots)"/></svg>');
          pointer-events: none;
        }

        .footer-content {
          position: relative;
          z-index: 1;
        }

        .container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 20px;
        }

        .footer-main {
          padding: 60px 0 40px;
        }

        .footer-grid {
          display: grid;
          grid-template-columns: 2fr 1fr 1fr 1fr;
          gap: 40px;
          margin-bottom: 20px;
        }

        .footer-column h3 {
          font-size: 1.25rem;
          font-weight: bold;
          margin-bottom: 20px;
          color: #ecfdf5;
          position: relative;
          padding-bottom: 8px;
        }

        .footer-column h3::after {
          content: "";
          position: absolute;
          bottom: 0;
          left: 0;
          width: 30px;
          height: 2px;
          background: #10b981;
          border-radius: 1px;
        }

        .footer-logo {
          max-height: 64px;
          margin-bottom: 16px;
          filter: brightness(0) invert(1);
        }

        .footer-description {
          color: #d1fae5;
          line-height: 1.6;
          margin-bottom: 20px;
          font-size: 0.95rem;
        }

        .footer-menu {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .footer-menu li {
          margin-bottom: 12px;
        }

        .footer-menu a {
          color: #d1fae5;
          text-decoration: none;
          font-size: 0.9rem;
          transition: all 0.3s ease;
          display: inline-block;
          position: relative;
        }

        .footer-menu a:hover {
          color: #6ee7b7;
          transform: translateX(4px);
        }

        .contact-item {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 12px;
          color: #d1fae5;
          font-size: 0.9rem;
        }

        .contact-icon {
          width: 20px;
          height: 20px;
          background: rgba(16, 185, 129, 0.2);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 0.8rem;
          flex-shrink: 0;
        }

        .social-links {
          display: flex;
          gap: 12px;
          flex-wrap: wrap;
        }

        .social-link {
          display: flex;
          align-items: center;
          gap: 8px;
          color: #d1fae5;
          text-decoration: none;
          font-size: 0.9rem;
          padding: 8px 12px;
          background: rgba(16, 185, 129, 0.1);
          border-radius: 8px;
          transition: all 0.3s ease;
          border: 1px solid rgba(16, 185, 129, 0.2);
        }

        .social-link:hover {
          background: rgba(16, 185, 129, 0.2);
          color: #6ee7b7;
          transform: translateY(-2px);
          border-color: rgba(16, 185, 129, 0.4);
        }

        .social-icon {
          font-size: 1.1rem;
        }

        .footer-bottom {
          border-top: 1px solid rgba(16, 185, 129, 0.2);
          padding: 20px 0;
          background: rgba(0, 0, 0, 0.1);
        }

        .footer-bottom-content {
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 0.875rem;
          color: #a7f3d0;
          flex-wrap: wrap;
          gap: 16px;
        }

        .footer-bottom a {
          color: #6ee7b7;
          text-decoration: none;
          transition: color 0.3s ease;
        }

        .footer-bottom a:hover {
          color: #34d399;
        }

        .loading-skeleton {
          background: rgba(255, 255, 255, 0.1);
          border-radius: 4px;
          height: 20px;
          margin-bottom: 8px;
          animation: pulse 1.5s ease-in-out infinite;
        }

        @keyframes pulse {
          0%,
          100% {
            opacity: 1;
          }
          50% {
            opacity: 0.5;
          }
        }

        /* Responsive Design */
        @media (max-width: 1024px) {
          .footer-grid {
            grid-template-columns: 2fr 1fr 1fr;
            gap: 30px;
          }
        }

        @media (max-width: 768px) {
          .footer-main {
            padding: 40px 0 30px;
          }

          .footer-grid {
            grid-template-columns: 1fr 1fr;
            gap: 30px;
          }
        }

        @media (max-width: 576px) {
          .footer-grid {
            grid-template-columns: 1fr;
            gap: 30px;
            text-align: center;
          }

          .footer-column h3::after {
            left: 50%;
            transform: translateX(-50%);
          }

          .footer-bottom-content {
            flex-direction: column;
            text-align: center;
            gap: 12px;
          }

          .social-links {
            justify-content: center;
          }
        }
      `}</style>

      <div className="footer-content">
        <div className="footer-main">
          <div className="container">
            <div className="footer-grid">
              {/* Columna 1: Información de la empresa */}
              <div className="footer-column">
                {settingsLoading ? (
                  <>
                    <div
                      className="loading-skeleton"
                      style={{
                        width: "150px",
                        height: "40px",
                        marginBottom: "16px",
                      }}
                    ></div>
                    <div
                      className="loading-skeleton"
                      style={{ width: "100%" }}
                    ></div>
                    <div
                      className="loading-skeleton"
                      style={{ width: "80%" }}
                    ></div>
                  </>
                ) : (
                  <>
                    {siteData.logo ? (
                      <img
                        src={`${API_BASE_URL}${siteData.logo}`}
                        alt={siteData.name}
                        className="footer-logo"
                      />
                    ) : (
                      <h3 style={{ marginBottom: "16px" }}>{siteData.name}</h3>
                    )}

                    <p className="footer-description">{siteData.description}</p>

                    {/* Información de contacto */}
                    <div>
                      <div className="contact-item">
                        <div className="contact-icon">
                          <i className="fas fa-envelope"></i>
                        </div>
                        <a
                          href={`mailto:${siteData.email}`}
                          style={{ color: "inherit", textDecoration: "none" }}
                        >
                          {siteData.email}
                        </a>
                      </div>

                      <div className="contact-item">
                        <div className="contact-icon">
                          <i className="fas fa-phone-alt"></i>
                        </div>
                        <a
                          href={`tel:${siteData.phone}`}
                          style={{ color: "inherit", textDecoration: "none" }}
                        >
                          {siteData.phone}
                        </a>
                      </div>

                      {siteData.address && (
                        <div className="contact-item">
                          <div className="contact-icon">
                            <i className="fas fa-map-marker-alt"></i>
                          </div>
                          <span>{siteData.address}</span>
                        </div>
                      )}
                    </div>
                  </>
                )}
              </div>

              {/* Columna 2: Menú de navegación */}
              <div className="footer-column">
                <h3>Navegación</h3>
                {mainMenuLoading ? (
                  <>
                    {[1, 2, 3, 4, 5].map((i) => (
                      <div
                        key={i}
                        className="loading-skeleton"
                        style={{ width: `${60 + Math.random() * 40}%` }}
                      ></div>
                    ))}
                  </>
                ) : (
                  <ul className="footer-menu">
                    {mainMenuItems.length > 0 ? (
                      mainMenuItems.slice(0, 6).map((item) => (
                        <li key={item.id}>
                          <Link to={item.url || "#"}>{item.title}</Link>
                        </li>
                      ))
                    ) : (
                      // Menú por defecto si no hay datos del API
                      <>
                        <li>
                          <Link to="/categoria/noticias">Noticias</Link>
                        </li>
                        <li>
                          <Link to="/nosotros">Nosotros</Link>
                        </li>
                        <li>
                          <Link to="/medops">Miembros</Link>
                        </li>
                        <li>
                          <Link to="/contacto">Contáctenos</Link>
                        </li>
                        <li>
                          <Link to="/publicidad">Publicidad</Link>
                        </li>
                      </>
                    )}
                  </ul>
                )}
              </div>

              {/* Columna 3: Menú Footer (ID 2) */}
              <div className="footer-column">
                <h3>Enlaces</h3>
                {footerMenuLoading ? (
                  <>
                    {[1, 2, 3, 4].map((i) => (
                      <div
                        key={i}
                        className="loading-skeleton"
                        style={{ width: `${60 + Math.random() * 40}%` }}
                      ></div>
                    ))}
                  </>
                ) : (
                  <ul className="footer-menu">
                    {footerMenuItems.length > 0 ? (
                      footerMenuItems.map((item) => (
                        <li key={item.id}>
                          <Link to={item.url || "#"}>{item.title}</Link>
                        </li>
                      ))
                    ) : (
                      // Enlaces por defecto si no hay menú footer
                      <>
                        <li>
                          <Link to="/servicios">Servicios</Link>
                        </li>
                        <li>
                          <Link to="/publicidad">Publicidad</Link>
                        </li>
                        <li>
                          <Link to="/eventos">Eventos</Link>
                        </li>
                        <li>
                          <Link to="/directorio">Directorio</Link>
                        </li>
                      </>
                    )}
                  </ul>
                )}
              </div>

              {/* Columna 4: Menú Legal (ID 5) */}
              <div className="footer-column">
                <h3>Legal</h3>
                {legalMenuLoading ? (
                  <>
                    {[1, 2, 3, 4].map((i) => (
                      <div
                        key={i}
                        className="loading-skeleton"
                        style={{ width: `${60 + Math.random() * 40}%` }}
                      ></div>
                    ))}
                  </>
                ) : (
                  <ul className="footer-menu">
                    {legalMenuItems.length > 0 ? (
                      legalMenuItems.map((item) => (
                        <li key={item.id}>
                          <Link to={item.url || "#"}>{item.title}</Link>
                        </li>
                      ))
                    ) : (
                      // Enlaces legales por defecto
                      <>
                        <li>
                          <Link to="/terminos">Términos y Condiciones</Link>
                        </li>
                        <li>
                          <Link to="/privacidad">Políticas de Privacidad</Link>
                        </li>
                        <li>
                          <Link to="/datos">Tratamiento de Datos</Link>
                        </li>
                        <li>
                          <Link to="/cookies">Política de Cookies</Link>
                        </li>
                      </>
                    )}
                  </ul>
                )}
              </div>
            </div>

            {/* Nueva fila: Redes sociales centradas */}
            <div
              style={{
                textAlign: "center",
                paddingTop: "40px",
                borderTop: "1px solid rgba(16, 185, 129, 0.2)",
                marginTop: "40px",
              }}
            >
              <h3
                style={{
                  fontSize: "1.25rem",
                  fontWeight: "bold",
                  marginBottom: "20px",
                  color: "#ecfdf5",
                }}
              >
                Síguenos en Redes Sociales
              </h3>

              <div
                className="social-links"
                style={{ justifyContent: "center" }}
              >
                {siteData.social.facebook && (
                  <a
                    href={siteData.social.facebook}
                    className="social-link"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="social-icon">
                      <i className="fab fa-facebook-f"></i>
                    </span>
                    {/* Facebook */}
                  </a>
                )}

                {siteData.social.twitter && (
                  <a
                    href={siteData.social.twitter}
                    className="social-link"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="social-icon">
                      <i className="fab fa-twitter"></i>
                    </span>
                    {/*Twitter*/}
                  </a>
                )}

                {siteData.social.instagram && (
                  <a
                    href={siteData.social.instagram}
                    className="social-link"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="social-icon">
                      <i className="fab fa-instagram"></i>
                    </span>
                    {/*Instagram*/}
                  </a>
                )}

                {siteData.social.youtube && (
                  <a
                    href={siteData.social.youtube}
                    className="social-link"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="social-icon">
                      <i className="fab fa-youtube"></i>
                    </span>
                    {/*YouTube*/}
                  </a>
                )}

                {siteData.social.linkedin && (
                  <a
                    href={siteData.social.linkedin}
                    className="social-link"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="social-icon">
                      <i className="fab fa-linkedin-in"></i>
                    </span>
                    {/*LinkedIn*/}
                  </a>
                )}

                {/* Redes sociales por defecto si no hay datos del API */}
                {!siteData.social.facebook &&
                  !siteData.social.twitter &&
                  !siteData.social.instagram && (
                    <>
                      <a href="#" className="social-link">
                        <span className="social-icon">
                          <i className="fab fa-facebook-f"></i>
                        </span>
                        Facebook
                      </a>
                      <a href="#" className="social-link">
                        <span className="social-icon">
                          <i className="fab fa-twitter"></i>
                        </span>
                        Twitter
                      </a>
                      <a href="#" className="social-link">
                        <span className="social-icon">
                          <i className="fab fa-instagram"></i>
                        </span>
                        Instagram
                      </a>
                    </>
                  )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer bottom */}
      <div className="footer-bottom">
        <div className="container">
          <div className="footer-bottom-content">
            <p>© 2025 {siteData.name}. Todos los derechos reservados.</p>
            <p>
              Diseño y Desarrollo:{" "}
              <a
                href="https://intarmedia.net"
                target="_blank"
                rel="noopener noreferrer"
              >
                Intarmedia
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
